module.exports = __webpack_public_path__ + "img/spain-neoplasm-male.b770ca14.png";